import { createAuthClient } from "better-auth/react"
import { customSessionClient, twoFactorClient, emailOTPClient, magicLinkClient, multiSessionClient, organizationClient } from "better-auth/client/plugins";
import type { auth } from "../auth";
import { ac, owner, admin, member } from "../permissions";

// Define a type for the auth client configuration
export type AuthClientConfig = {
  baseURL?: string;
  debug?: boolean;
};

// Default configuration that can be overridden
const defaultConfig: AuthClientConfig = {
  baseURL: process.env.NEXT_PUBLIC_BETTER_AUTH_URL as string,
  debug: process.env.NODE_ENV !== "production",
};

// Create a singleton instance with the default configuration
export const authClient = createAuthClient({
  baseURL: defaultConfig.baseURL,
  plugins: [
    customSessionClient<typeof auth>(),
    twoFactorClient(),
    multiSessionClient(),
    emailOTPClient(),
    magicLinkClient(),
    organizationClient({
      ac,
      roles: {
        owner,
        admin,
        member,
      }
    }),
  ],
});

const signIn = authClient.signIn;
const signUp = authClient.signUp;
const signOut = authClient.signOut;
const useSession = authClient.useSession;
const getSession = authClient.getSession;

export { signIn, signUp, signOut, useSession, getSession };